import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  createAdProvider,
  listAdProviders,
  setAdProviderStatus,
  updateAdProvider,
} from './ad-providers';
import type { CreateAdProviderReq } from './ad-providers';
import { adProviderKeys } from './query-keys';
import type { DictQuery } from './types';

export function useAdProviderList(query: DictQuery = {}) {
  return useQuery({
    queryKey: adProviderKeys.list(query),
    queryFn: () => listAdProviders(query),
  });
}

export function useCreateAdProvider() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: createAdProvider,
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: adProviderKeys.lists() });
    },
  });
}

export function useUpdateAdProvider() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ providerId, ...req }: { providerId: number } & CreateAdProviderReq) =>
      updateAdProvider(providerId, req),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: adProviderKeys.lists() });
    },
  });
}

export function useSetAdProviderStatus() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ providerId, status }: { providerId: number; status: 0 | 1 }) =>
      setAdProviderStatus(providerId, status),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: adProviderKeys.lists() });
    },
  });
}
